import React, { useCallback, useEffect, useState } from "react";
import styles from "./StoreFrontCategory.module.scss";
import StoreTabSelector from "../layout/StoreTabSelector";
import SortComponent from "../components/sort-component/SortComponent";
import ProductItem from "../components/product-item/ProductItem";
import { useParams } from "react-router-dom";
import CheckboxFilterComponent, { CheckboxFilterType } from "../components/filter-component/checkbox-filter-component/CheckboxFilterComponent";
import RangeFilterComponent from "../components/filter-component/range-filter-component/RangeFilterComponent";
import solarProductService from "../../../httpService/SolarProductService";
import { toast } from "react-toastify";
import { BounceLoader } from "react-spinners";
import { SolarProduct } from "../../../model/solar-product/solar-product";
import { SolarProductObject } from "../../../model/solar-product/solar-product-with-recommendations";
import { CategoryWithProduct } from "../../../model/solar-product/category-with-product";
import { BurgerOutline } from "../../../assets/icons";

export interface checkboxFilterComponentProps {
	filterFieldLabel: string;
	filterField: string;
	data: CheckboxFilterType[];
}

export interface rangeFilterComponentProps {
	filterFieldLabel: string;
	filterField: string;
	minValue?: number;
	maxValue?: number;
	unitPlaceholder?: string;
}

type Props = {};

const StoreFrontCategory: React.FC<Props> = (props: Props) => {
	const { category } = useParams();
	const [loading, setLoading] = useState(false);

	const [isFilterForMobileVisible, setIsFilterForMobileVisible] = useState(false);

	const [finalQuery, setFinalQuery] = useState("");

	const [categoryWithSolarProducts, setCategoryWithSolarProducts] = useState<CategoryWithProduct>();

	const checkBoxFilterData: checkboxFilterComponentProps[] = [
		{
			filterFieldLabel: "Capacity",
			filterField: "Capacity",
			data: [
				{ label: "1 - 3", value: "1-3" },
				{ label: "4 - 6", value: "4-6" },
				{ label: "7 - 9", value: "7-9" },
				{ label: "10 - 14", value: "10-14" },
				{ label: "15 - Above", value: "15-Above" },
			],
		},
		{
			filterFieldLabel: "Pricing",
			filterField: "Pricing",
			data: [
				{ label: `₦${(100_000).toLocaleString()} - ₦${(300_000).toLocaleString()}`, value: `${100_000}-${300_000}` },
				{ label: `₦${(400_000).toLocaleString()} - ₦${(600_000).toLocaleString()}`, value: `${400_000}-${600_000}` },
				{ label: `₦${(700_000).toLocaleString()} - ₦${(900_000).toLocaleString()}`, value: `${700_000}-${900_000}` },
				{ label: `₦${(1_000_000).toLocaleString()} - ₦${(1_400_000).toLocaleString()}`, value: `${1_000_000}-${1_400_000}` },
				{ label: `₦${(1_500_000).toLocaleString()} - Above`, value: `${1_500_000}-Above` },
			],
		},
	];

	const pricingFilterData: rangeFilterComponentProps[] = [
		{
			filterFieldLabel: "Capacity",
			filterField: "Capacity",
			unitPlaceholder: "",
		},

		{
			filterFieldLabel: "Pricing",
			filterField: "Price",
			unitPlaceholder: "NGN",
		},
	];

	const [capacityQueryParams, setCapacityQueryParams] = useState("");
	const [pricingQueryParams, setPricingQueryParams] = useState("");
	const [sortQueryParams, setSortQueryParams] = useState("");

	const fetchProductsFromCategory = useCallback(async () => {
		if (category == null) return;
		try {
			setLoading(true);

			const response = await solarProductService.getProductsFromCategory(category, finalQuery);

			const data = response.data;

			setCategoryWithSolarProducts(data.productsByCategories[0]);

			console.log(data);
		} catch (error) {
			toast.error("Something went wrong while fetching Products in Categories");
		} finally {
			setLoading(false);
		}
	}, [category, finalQuery]);

	useEffect(() => {
		fetchProductsFromCategory();
	}, []);

	useEffect(() => {
		fetchProductsFromCategory();
	}, [fetchProductsFromCategory]);

	useEffect(() => {
		const arr = [];
		if (capacityQueryParams != "") arr.push(capacityQueryParams);
		if (pricingQueryParams != "") arr.push(pricingQueryParams);
		if (sortQueryParams != "") arr.push(sortQueryParams);
		setFinalQuery(arr.join("&"));
	}, [capacityQueryParams, pricingQueryParams, sortQueryParams]);

	const handleWishlistChange = (productId: string, isInWishlist: boolean) => {
		setCategoryWithSolarProducts(prevCategoryWithSolarProducts => {
			if (!prevCategoryWithSolarProducts) return prevCategoryWithSolarProducts;

			return {
				...prevCategoryWithSolarProducts,
				productsAndAvailableOffers: prevCategoryWithSolarProducts.productsAndAvailableOffers?.map(product =>
					product.solarProduct.id === productId
						? {
								...product,
								solarProduct: {
									...product.solarProduct,
									isWishlisted: isInWishlist,
								},
						  }
						: product
				),
			};
		});
	};

	return (
		<>
			<StoreTabSelector />
			<div className={styles.container}>
				<div className={styles.storeContainer}>
					<div className={styles.leftContainer}>
						<div className={styles.title}>
							{category}
							<div className={styles.burgerForMobile} onClick={() => setIsFilterForMobileVisible(prev => !prev)}>
								<BurgerOutline />
							</div>
						</div>
						<div className={styles.responsive}>
							<div className={styles.filterForMobile}>
								{isFilterForMobileVisible && (
									<>
										<RangeFilterComponent
											key={pricingFilterData[0].filterField}
											x={pricingFilterData[0]}
											onFilterChange={queryParams => setCapacityQueryParams(queryParams)}
										/>
										<RangeFilterComponent
											key={pricingFilterData[1].filterField}
											x={pricingFilterData[1]}
											onFilterChange={queryParams => setPricingQueryParams(queryParams)}
										/>
									</>
								)}
							</div>
							<SortComponent onSortChange={queryParams => setSortQueryParams(queryParams)} />
						</div>
						{checkBoxFilterData.map((x, i) => (
							<CheckboxFilterComponent key={i} x={x} behaveLikeRange onFilterChange={queryParams => setCapacityQueryParams(queryParams)} />
						))}
						<div className={styles.filterForDesktop}>
							{/* <RangeFilterComponent key={pricingFilterData[0].filterField} x={pricingFilterData[0]} onFilterChange={(queryParams) => setCapacityQueryParams(queryParams)}/> */}
							<RangeFilterComponent
								key={pricingFilterData[1].filterField}
								x={pricingFilterData[1]}
								onFilterChange={queryParams => setPricingQueryParams(queryParams)}
							/>
						</div>
						{/* {
							pricingFilterData.map(x =>
								<RangeFilterComponent key={x.filterField} x={x} onFilterChange={(queryParams) => setPricingQueryParams(queryParams)}/>
						)} */}
					</div>
					<div className={styles.rightContainer}>
						<div className={styles.topBar}>
							<div>
								{loading && (
									<div className={styles.loaderContainer}>
										<BounceLoader key={1} color="#DE841B" size={30} />
									</div>
								)}
							</div>
							<div className={styles.nonResponsive}>
								<SortComponent onSortChange={queryParams => setSortQueryParams(queryParams)} />
							</div>
						</div>
						{!loading && (
							<div className={styles.productGrid}>
								{categoryWithSolarProducts?.productsAndAvailableOffers?.map((x, i) => (
									<div key={i} className={styles.productPosition}>
										<ProductItem onWishlistChange={handleWishlistChange} key={x.solarProduct.id} solarProduct={x} />
									</div>
								))}
							</div>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default StoreFrontCategory;
